import { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const KeyIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="8" cy="15" r="4" />
    <line x1="11" y1="12" x2="21" y2="2" />
    <line x1="18" y1="5" x2="21" y2="8" />
  </svg>
);
const ScriptIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="3" y="3" width="18" height="18" rx="2" />
    <line x1="7" y1="8" x2="17" y2="8" />
    <line x1="7" y1="12" x2="17" y2="12" />
    <line x1="7" y1="16" x2="12" y2="16" />
  </svg>
);
const ContactIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="3" y="3" width="18" height="18" rx="2" />
    <circle cx="12" cy="10" r="3" />
    <path d="M6 21v-1a6 6 0 0 1 12 0v1" />
  </svg>
);
const ResourceIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
    <path d="M4 4.5A2.5 2.5 0 0 1 6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5z" />
    <line x1="8" y1="7" x2="16" y2="7" />
    <line x1="8" y1="11" x2="14" y2="11" />
  </svg>
);
const TrainingIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M22 10 12 5 2 10l10 5 10-5Z" />
    <path d="M6 12v5c3 2 9 2 12 0v-5" />
    <path d="M22 10v6" />
  </svg>
);
const CalIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="3" y="4" width="18" height="18" rx="2" />
    <line x1="16" y1="2" x2="16" y2="6" />
    <line x1="8" y1="2" x2="8" y2="6" />
    <line x1="3" y1="10" x2="21" y2="10" />
  </svg>
);
const VideoIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polygon points="23 7 16 12 23 17 23 7" />
    <rect x="1" y="5" width="15" height="14" rx="2" />
  </svg>
);
const ExtIcon = () => (
  <svg
    width="13"
    height="13"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
    <polyline points="15 3 21 3 21 9" />
    <line x1="10" y1="14" x2="21" y2="3" />
  </svg>
);
const ChevronIcon = ({ isOpen = false }) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ transform: isOpen ? "rotate(180deg)" : "rotate(0deg)", transition: "transform 0.2s" }}
  >
    <polyline points="6 9 12 15 18 9" />
  </svg>
);

// Icons for calendar
const ChevronLeftIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="15 18 9 12 15 6" />
  </svg>
);
const ChevronRightIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="9 18 15 12 9 6" />
  </svg>
);
const TrashIcon = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="3 6 5 6 21 6" />
    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
  </svg>
);

const tools = [
  { icon: <KeyIcon />, label: "CARRIER ACCESS", link: "/carrier-login" },
  { icon: <ScriptIcon />, label: "SCRIPTS", link: "/scripts" },
  { icon: <ResourceIcon />, label: "AGENT RESOURCES", link: "/agent-resources" },
  { icon: <ContactIcon />, label: "CARRIER CONTACTS", link: "/carrier-contacts" },
  { icon: <TrainingIcon />, label: "TRAINING", link: "/training" },
];

const agencyPlatforms = [
  { label: "HCMS", link: "https://hcms.chims.uppatop.com/login" },
  { label: "Bonus Structure", pdf: "/Bonus-structure.pdf" },
  {
    label: "IP Leaderboard",
    link: "https://ww3.familyfirstlife.com/dashboard#",
  },
];

const agentAccess = [
  { 
    label: "Carrier Toolkit", 
    hasDropdown: true,
    options: [
      { label: "FEX Toolkit", link: "https://app.insurancetoolkits.com/" },
      { label: "Integrity Toolkit", link: "https://connect.integrity.com/agent/dashboard?quick-quote-initiated=true" }
    ]
  },
  { label: "CRM Access", hasExt: true, link: "https://app.clydios.com" },
];

const operations = [
  { label: "Time Off", icon: <CalIcon /> },
  {
    label: "Update Info",
    icon: (
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx="12" cy="8" r="4" />
        <path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" />
      </svg>
    ),
  },
  {
    label: "Hiring Portal",
    icon: (
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx="9" cy="8" r="4" />
        <path d="M3 20c0-4 2.7-7 6-7s6 3 6 7" />
        <path d="M16 11l2 2 4-4" />
      </svg>
    ),
    link: "https://form.jotform.com/260434781561155",
  },
];

export default function Home() {
  const [addFollowUp, setAddFollowUp] = useState(false);
  const [openToolkit, setOpenToolkit] = useState(false);
  const [followUps, setFollowUps] = useState(() => {
    // Initialize with some sample follow-ups
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);
    const nextWeek = new Date(today);
    nextWeek.setDate(today.getDate() + 7);
    
    const formatDate = (date) => date.toISOString().split('T')[0];
    return [
      { id: 1, name: "John Smith", date: formatDate(tomorrow) },
      { id: 2, name: "Sarah Lee", date: formatDate(nextWeek) },
    ];
  });
  const [newFollowUpName, setNewFollowUpName] = useState("");
  const [newFollowUpDate, setNewFollowUpDate] = useState("");
  const [calendarDate, setCalendarDate] = useState(new Date());
  
  const navigate = useNavigate();
  const toolkitRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (toolkitRef.current && !toolkitRef.current.contains(event.target)) {
        setOpenToolkit(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleToolkitClick = () => {
    setOpenToolkit(!openToolkit);
  };

  const handleOptionClick = (link) => {
    window.open(link, "_blank");
    setOpenToolkit(false);
  };

  const openZoomMeeting = () => {
    window.open(
      "https://app.zoom.us/wc/join/5305705567?pwd=wintheday",
      "_blank"
    );
  };

  const openDailyConnect = () => {
    window.open("https://meet.google.com/vsq-kpda-jht", "_blank");
  };

  // Follow-up helpers
  const addNewFollowUp = () => {
    if (!newFollowUpName.trim() || !newFollowUpDate) return;
    const newId = Math.max(0, ...followUps.map(f => f.id)) + 1;
    setFollowUps([...followUps, { id: newId, name: newFollowUpName.trim(), date: newFollowUpDate }]);
    setNewFollowUpName("");
    setNewFollowUpDate("");
    setAddFollowUp(false);
  };

  const deleteFollowUp = (id) => {
    setFollowUps(followUps.filter(f => f.id !== id));
  };

  // Calendar helpers
  const getDaysInMonth = (year, month) => new Date(year, month + 1, 0).getDate();
  const getFirstDayOfMonth = (year, month) => new Date(year, month, 1).getDay(); // 0 = Sunday
  
  const prevMonth = () => {
    setCalendarDate(new Date(calendarDate.getFullYear(), calendarDate.getMonth() - 1, 1));
  };
  
  const nextMonth = () => {
    setCalendarDate(new Date(calendarDate.getFullYear(), calendarDate.getMonth() + 1, 1));
  };
  
  const year = calendarDate.getFullYear();
  const month = calendarDate.getMonth();
  const daysInMonth = getDaysInMonth(year, month);
  const firstDayIndex = getFirstDayOfMonth(year, month);
  
  // Get days from previous month
  const prevMonthDays = getDaysInMonth(year, month - 1);
  const calendarDays = [];
  
  // Previous month days
  for (let i = firstDayIndex - 1; i >= 0; i--) {
    calendarDays.push({ date: prevMonthDays - i, isCurrentMonth: false });
  }
  // Current month days
  for (let i = 1; i <= daysInMonth; i++) {
    calendarDays.push({ date: i, isCurrentMonth: true });
  }
  // Next month days to complete 6 rows (42 days)
  const remaining = 42 - calendarDays.length;
  for (let i = 1; i <= remaining; i++) {
    calendarDays.push({ date: i, isCurrentMonth: false });
  }
  
  const getFollowUpsForDate = (day, isCurrentMonth) => {
    if (!isCurrentMonth) return [];
    const dateStr = `${year}-${String(month + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
    return followUps.filter(f => f.date === dateStr);
  };
  
  // Upcoming follow-ups (sorted)
  const upcomingFollowUps = [...followUps].sort((a, b) => a.date.localeCompare(b.date));
  
  const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  const weekDays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  return (
    <div
      className="home-command-page"
      style={{
        minHeight: "100vh",
        backgroundColor: "#0e0e0e",
        color: "#e8e0cc",
        fontFamily: "Inter, Manrope, Arial, sans-serif",
        padding: "24px 20px",
        boxSizing: "border-box",
      }}
    >
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&family=Manrope:wght@400;500;600;700;800&display=swap');
        * { box-sizing: border-box; }
        .ap-btn-gold {
          background: #d4a017;
          color: #0e0e0e;
          border: none;
          padding: 14px 32px;
          font-size: 13px;
          font-weight: 600;
          letter-spacing: 0.12em;
          cursor: pointer;
          border-radius: 6px;
          display: flex; align-items: center; gap: 10px;
          transition: background 0.18s, transform 0.12s;
          font-family: inherit;
        }
        .ap-btn-gold:hover { background: #e5b420; transform: translateY(-1px); }
        .ap-btn-gold:active { transform: translateY(0); }
        .ap-card {
          background: #161616;
          border: 1px solid #2a2618;
          border-radius: 14px;
          transition: border-color 0.24s ease, transform 0.24s ease, box-shadow 0.24s ease;
          min-width: 0;
          max-width: 100%;
        }
        .ap-card:hover {
          border-color: #3d3520;
          transform: translateY(-3px);
          box-shadow: 0 18px 36px rgba(0, 0, 0, 0.22), 0 0 24px rgba(212, 160, 23, 0.08);
        }
        .ap-tool-card {
          background: #161616;
          border: 1px solid #2a2618;
          border-radius: 14px;
          display: flex; flex-direction: column;
          align-items: center; justify-content: center;
          gap: 14px;
          padding: 32px 16px;
          cursor: pointer;
          transition: border-color 0.24s ease, background 0.24s ease, transform 0.24s ease, box-shadow 0.24s ease;
          min-height: 130px;
        }
        .ap-tool-card:hover {
          border-color: #d4a017;
          background: #1c1a10;
          transform: translateY(-3px);
          box-shadow: 0 18px 34px rgba(0, 0, 0, 0.24), 0 0 22px rgba(212, 160, 23, 0.1);
        }
        .ap-tool-icon {
          width: 44px; height: 44px;
          background: #1e1c10;
          border-radius: 10px;
          display: flex; align-items: center; justify-content: center;
          color: #d4a017;
          border: 1px solid #2e2a10;
          transition: transform 0.24s ease, filter 0.24s ease;
        }
        .ap-tool-card:hover .ap-tool-icon {
          transform: scale(1.05);
          filter: drop-shadow(0 0 10px rgba(212, 160, 23, 0.22));
        }
        .ap-tool-label {
          font-size: 11px;
          font-weight: 600;
          letter-spacing: 0.1em;
          color: #a09070;
        }
        .ap-btn-outline {
          background: #1c1c1c;
          color: #c8b880;
          border: 1px solid #2e2a18;
          padding: 9px 14px;
          font-size: 11px;
          font-weight: 600;
          letter-spacing: 0.08em;
          cursor: pointer;
          border-radius: 7px;
          display: flex; align-items: center; gap: 7px;
          transition: border-color 0.22s ease, background 0.22s ease, transform 0.16s ease, box-shadow 0.22s ease;
          font-family: inherit;
          white-space: nowrap;
        }
        .ap-btn-outline:hover {
          border-color: #d4a017;
          background: #201e10;
          transform: scale(1.02);
          box-shadow: 0 0 18px rgba(212, 160, 23, 0.12);
        }
        .ap-btn-outline:active { transform: scale(0.98); }
        .ap-btn-sm-gold {
          background: #2a2310;
          color: #d4a017;
          border: 1px solid #3a3010;
          padding: 9px 14px;
          font-size: 11px;
          font-weight: 600;
          letter-spacing: 0.08em;
          cursor: pointer;
          border-radius: 7px;
          display: flex; align-items: center; gap: 6px;
          transition: background 0.22s ease, transform 0.16s ease, box-shadow 0.22s ease, border-color 0.22s ease;
          font-family: inherit;
          white-space: nowrap;
        }
        .ap-btn-sm-gold:hover {
          background: #352c12;
          transform: scale(1.02);
          box-shadow: 0 0 18px rgba(212, 160, 23, 0.14);
        }
        .ap-btn-sm-gold:active { transform: scale(0.98); }
        .ap-join-btn {
          background: #d4a017;
          color: #0e0e0e;
          border: none;
          padding: 16px 24px;
          font-size: 12px;
          font-weight: 700;
          letter-spacing: 0.14em;
          cursor: pointer;
          border-radius: 8px;
          display: flex; align-items: center; justify-content: center; gap: 8px;
          width: 100%;
          transition: background 0.22s ease, transform 0.16s ease, box-shadow 0.22s ease;
          font-family: inherit;
        }
        .ap-join-btn:hover {
          background: #e5b420;
          transform: scale(1.02);
          box-shadow: 0 0 22px rgba(212, 160, 23, 0.18);
        }
        .ap-join-btn:active { transform: scale(0.98); }
        .ap-footer-link {
          display: flex; align-items: center; justify-content: space-between;
          padding: 14px 0;
          border-bottom: 1px solid #1e1e1e;
          color: #c8b880;
          font-size: 13px;
          cursor: pointer;
          transition: color 0.15s;
          gap: 8px;
        }
        .ap-footer-link:last-child { border-bottom: none; }
        .ap-footer-link:hover { color: #d4a017; }
        .ap-footer-icon { color: #5a5040; flex-shrink: 0; }
        .ap-section-label {
          font-size: 10px;
          font-weight: 700;
          letter-spacing: 0.18em;
          color: #5a5040;
          margin-bottom: 12px;
          border-bottom: 1px solid #1e1c14;
          padding-bottom: 8px;
        }
        .ap-hero {
          background: #141410;
          border: 1px solid #2a2618;
          border-radius: 18px;
          padding: 48px 32px;
          text-align: center;
          position: relative;
          overflow: hidden;
          margin-bottom: 20px;
        }
        .ap-hero::before {
          content: '';
          position: absolute;
          top: -60px; left: 50%; transform: translateX(-50%);
          width: 300px; height: 200px;
          background: radial-gradient(ellipse, rgba(212,160,23,0.08) 0%, transparent 70%);
          pointer-events: none;
        }
        .ap-grid-3 {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 14px;
          margin-bottom: 20px;
        }
        @media (max-width: 640px) {
          .ap-grid-3 { grid-template-columns: repeat(3, 1fr); }
        }
        @media (max-width: 400px) {
          .ap-grid-3 { grid-template-columns: repeat(1, 1fr); gap: 10px; }
        }
        .ap-mid-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 14px;
          margin-bottom: 20px;
        }
        @media (max-width: 640px) {
          .ap-mid-grid { grid-template-columns: 1fr; }
        }
        .ap-footer-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 20px;
        }
        @media (max-width: 640px) {
          .ap-footer-grid { grid-template-columns: 1fr; gap: 8px; }
        }
        .ap-meeting-id-box {
          background: #1a1810;
          border: 1px solid #2a2618;
          border-radius: 10px;
          padding: 16px;
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 12px;
          margin-bottom: 16px;
        }
        .ap-mono { font-family: "Inter", "Manrope", Arial, sans-serif; }
        .ap-meeting-card {
          display: flex;
          flex-direction: column;
          overflow: hidden;
          min-height: 100%;
        }
        .ap-meeting-visual {
          position: relative;
          flex: 1 1 auto;
          min-height: 96px;
          margin-top: 16px;
          border: 1px solid rgba(212, 160, 23, 0.08);
          border-radius: 10px;
          overflow: hidden;
          background:
            linear-gradient(rgba(212, 160, 23, 0.045) 1px, transparent 1px),
            linear-gradient(90deg, rgba(212, 160, 23, 0.04) 1px, transparent 1px),
            radial-gradient(circle at 22% 28%, rgba(212, 160, 23, 0.12), transparent 26%),
            radial-gradient(circle at 78% 62%, rgba(34, 197, 94, 0.08), transparent 30%),
            #11110f;
          background-size: 24px 24px, 24px 24px, 100% 100%, 100% 100%, 100% 100%;
        }
        .ap-meeting-visual::before,
        .ap-meeting-visual::after {
          content: "";
          position: absolute;
          inset: 12%;
          border: 1px solid rgba(212, 160, 23, 0.12);
          border-radius: 50%;
          opacity: 0.55;
          animation: ap-orbit-pulse 8s ease-in-out infinite;
        }
        .ap-meeting-visual::after {
          inset: 28%;
          border-color: rgba(34, 197, 94, 0.09);
          animation-delay: -3s;
        }
        .ap-meeting-scan {
          position: absolute;
          top: 50%;
          left: 50%;
          width: 44%;
          height: 1px;
          background: linear-gradient(90deg, rgba(212, 160, 23, 0), rgba(212, 160, 23, 0.24));
          transform-origin: left center;
          animation: ap-radar-sweep 9s linear infinite;
        }
        @keyframes ap-orbit-pulse {
          0%, 100% { transform: scale(0.94); opacity: 0.34; }
          50% { transform: scale(1.04); opacity: 0.62; }
        }
        @keyframes ap-radar-sweep {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        .ap-live-dot {
          width: 7px; height: 7px;
          background: #22c55e;
          border-radius: 50%;
          display: inline-block;
          margin-right: 6px;
          animation: pulse-dot 2s ease-in-out infinite;
        }
        @keyframes pulse-dot {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.4; }
        }
        .ap-max {
          width: min(100%, 1240px);
          max-width: 100%;
          margin: 0 auto;
          padding-left: clamp(18px, 3vw, 34px);
          padding-right: clamp(18px, 3vw, 34px);
          box-sizing: border-box;
        }
        .ap-report-link {
          font-size: 11px;
          color: #5a5040;
          letter-spacing: 0.1em;
          cursor: pointer;
          text-decoration: underline;
          text-underline-offset: 3px;
          transition: color 0.15s;
        }
        .ap-report-link:hover { color: #d4a017; }
        .ap-dropdown {
          position: absolute;
          top: 100%;
          left: 0;
          right: 0;
          background: #1a1810;
          border: 1px solid #2e2a18;
          border-radius: 8px;
          margin-top: 4px;
          z-index: 10;
          box-shadow: 0 8px 16px rgba(0,0,0,0.4);
          overflow: hidden;
        }
        .ap-dropdown-item {
          padding: 12px 16px;
          font-size: 12px;
          color: #c8b880;
          cursor: pointer;
          transition: background 0.15s, color 0.15s;
          border-bottom: 1px solid #2a2618;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        .ap-dropdown-item:last-child {
          border-bottom: none;
        }
        .ap-dropdown-item:hover {
          background: #25220e;
          color: #d4a017;
        }
        .ap-relative {
          position: relative;
        }
        .ap-max {
          position: relative;
          isolation: isolate;
          animation: ap-page-enter 420ms ease both;
        }
        .ap-max::before,
        .ap-max::after {
          content: "";
          position: fixed;
          pointer-events: none;
          z-index: -1;
          border-radius: 50%;
          filter: blur(3px);
        }
        .ap-max::before {
          width: 48vw;
          height: 48vw;
          min-width: 360px;
          min-height: 360px;
          top: 7vh;
          right: -18vw;
          background: radial-gradient(circle, rgba(0, 224, 255, 0.11), rgba(0, 224, 255, 0.025) 44%, transparent 68%);
          animation: ap-orb-drift 18s ease-in-out infinite alternate;
        }
        .ap-max::after {
          width: 34vw;
          height: 34vw;
          min-width: 260px;
          min-height: 260px;
          left: -14vw;
          bottom: -12vh;
          background: radial-gradient(circle, rgba(212, 160, 23, 0.105), rgba(212, 160, 23, 0.02) 45%, transparent 70%);
          animation: ap-orb-drift 22s ease-in-out infinite alternate-reverse;
        }
        .ap-card,
        .ap-tool-card,
        .ap-hero {
          border-color: rgba(0, 224, 255, 0.12);
          background:
            linear-gradient(145deg, rgba(22, 25, 27, 0.78), rgba(8, 9, 11, 0.88)),
            rgba(12, 13, 14, 0.84);
          box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.045), 0 20px 52px rgba(0, 0, 0, 0.24);
          backdrop-filter: blur(14px);
        }
        .ap-card:hover,
        .ap-tool-card:hover {
          border-color: rgba(0, 224, 255, 0.34);
          box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.055), 0 28px 66px rgba(0, 0, 0, 0.32), 0 0 26px rgba(0, 224, 255, 0.09);
        }
        .ap-hero {
          min-height: clamp(320px, 42vh, 460px);
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: clamp(44px, 7vw, 78px) clamp(20px, 4vw, 56px);
          border-radius: 24px;
          border-color: rgba(212, 160, 23, 0.18);
          background:
            linear-gradient(rgba(0, 224, 255, 0.05) 1px, transparent 1px),
            linear-gradient(90deg, rgba(212, 160, 23, 0.035) 1px, transparent 1px),
            radial-gradient(circle at 50% 8%, rgba(0, 224, 255, 0.14), transparent 34%),
            radial-gradient(circle at 50% 86%, rgba(212, 160, 23, 0.12), transparent 38%),
            linear-gradient(145deg, rgba(18, 22, 24, 0.88), rgba(8, 9, 10, 0.94));
          background-size: 36px 36px, 36px 36px, 100% 100%, 100% 100%, 100% 100%;
        }
        .ap-hero::before {
          top: auto;
          left: -20%;
          bottom: 16%;
          transform: none;
          width: 140%;
          height: 1px;
          background: linear-gradient(90deg, transparent, rgba(0, 224, 255, 0.38), rgba(212, 160, 23, 0.25), transparent);
          animation: ap-scan-line 7s ease-in-out infinite;
        }
        .ap-hero::after {
          content: "";
          position: absolute;
          inset: 12%;
          border: 1px solid rgba(0, 224, 255, 0.08);
          border-radius: 50%;
          pointer-events: none;
          opacity: 0.55;
          animation: ap-orbit-pulse 8s ease-in-out infinite;
        }
        .ap-hero h1 {
          position: relative;
          z-index: 1;
          font-size: clamp(32px, 6vw, 58px) !important;
          font-weight: 700 !important;
          letter-spacing: 0.06em !important;
          color: #ffffff !important;
          text-shadow: 0 0 28px rgba(0, 224, 255, 0.16), 0 0 36px rgba(212, 160, 23, 0.12);
        }
        .ap-hero p {
          position: relative;
          z-index: 1;
          max-width: 620px !important;
          color: rgba(224, 235, 238, 0.72) !important;
          font-size: clamp(13px, 1.8vw, 16px) !important;
        }
        .ap-btn-gold {
          position: relative;
          z-index: 1;
          overflow: hidden;
          border: 1px solid rgba(212, 160, 23, 0.55);
          border-radius: 999px;
          padding: 17px 38px;
          font-weight: 800;
          background: linear-gradient(135deg, #d4a017, #f2c94c 48%, #936d09);
          box-shadow: 0 0 34px rgba(212, 160, 23, 0.2), inset 0 1px 0 rgba(255, 255, 255, 0.28);
          animation: ap-primary-pulse 3.8s ease-in-out infinite;
        }
        .ap-btn-gold::before {
          content: "";
          position: absolute;
          inset: 0;
          background: linear-gradient(110deg, transparent, rgba(255,255,255,0.36), transparent);
          transform: translateX(-120%);
          transition: transform 0.65s ease;
        }
        .ap-btn-gold:hover::before {
          transform: translateX(120%);
        }
        .ap-tool-card {
          position: relative;
          overflow: hidden;
          min-height: 152px;
          border-radius: 18px;
          border-color: rgba(212, 160, 23, 0.16);
        }
        .ap-tool-card::before {
          content: "";
          position: absolute;
          inset: 0;
          background: linear-gradient(110deg, transparent 0%, rgba(255,255,255,0.08) 45%, transparent 62%);
          transform: translateX(-120%);
          transition: transform 0.7s ease;
          pointer-events: none;
        }
        .ap-tool-card:hover::before {
          transform: translateX(120%);
        }
        .ap-tool-icon {
          width: 54px;
          height: 54px;
          border-radius: 16px;
          color: #00e0ff;
          border-color: rgba(0, 224, 255, 0.22);
          background: radial-gradient(circle at 35% 28%, rgba(0, 224, 255, 0.22), transparent 56%), rgba(9, 20, 24, 0.9);
          box-shadow: 0 0 20px rgba(0, 224, 255, 0.08);
        }
        .ap-tool-label {
          color: rgba(255, 255, 255, 0.9);
          font-weight: 800;
          letter-spacing: 0.14em;
        }
        .follow-up-calendar-card::before,
        .ap-meeting-card::before,
        .ap-toolkit-card::before {
          content: "";
          position: absolute;
          inset: 0;
          pointer-events: none;
          background: linear-gradient(120deg, rgba(0,224,255,0.055), transparent 34%, rgba(212,160,23,0.04));
          opacity: 0.75;
        }
        .follow-up-calendar-card,
        .ap-meeting-card,
        .ap-toolkit-card {
          position: relative;
          border-radius: 20px;
        }
        .calendar-header span {
          color: #ffffff !important;
          font-family: "Inter", "Manrope", Arial, sans-serif;
          letter-spacing: 0.08em;
        }
        .calendar-day {
          background: rgba(8, 12, 14, 0.82);
          border-color: rgba(0, 224, 255, 0.07);
          color: rgba(232, 246, 249, 0.72);
          transition: background 0.18s ease, border-color 0.18s ease, color 0.18s ease, box-shadow 0.18s ease, transform 0.18s ease;
        }
        .calendar-day.current-month {
          color: rgba(255, 255, 255, 0.95);
        }
        .calendar-day:hover {
          background: rgba(0, 224, 255, 0.07);
          border-color: rgba(0, 224, 255, 0.34);
          transform: translateY(-1px);
          box-shadow: 0 0 14px rgba(0, 224, 255, 0.1);
        }
        .calendar-day.has-events {
          background: rgba(212, 160, 23, 0.09);
          border-color: rgba(212, 160, 23, 0.38);
          box-shadow: 0 0 16px rgba(212, 160, 23, 0.11);
        }
        .calendar-day.has-events .event-count {
          animation: ap-primary-pulse 2.8s ease-in-out infinite;
        }
        .calendar-weekday {
          color: rgba(0, 224, 255, 0.8);
        }
        .calendar-nav-btn,
        .ap-btn-outline,
        .ap-btn-sm-gold {
          border-radius: 999px;
          background: rgba(0, 224, 255, 0.045);
          border-color: rgba(0, 224, 255, 0.16);
          color: rgba(226, 245, 248, 0.78);
        }
        .calendar-nav-btn:hover,
        .ap-btn-outline:hover,
        .ap-btn-sm-gold:hover {
          border-color: rgba(0, 224, 255, 0.5);
          background: rgba(0, 224, 255, 0.08);
          box-shadow: 0 0 20px rgba(0, 224, 255, 0.12);
        }
        .ap-meeting-card h2 {
          color: #ffffff !important;
          font-weight: 700 !important;
          letter-spacing: 0.04em;
        }
        .ap-meeting-id-box {
          background: rgba(7, 12, 14, 0.72);
          border-color: rgba(0, 224, 255, 0.12);
          box-shadow: inset 0 1px 0 rgba(255,255,255,0.035);
        }
        .ap-join-btn {
          position: relative;
          overflow: hidden;
          border: 1px solid rgba(34, 197, 94, 0.24);
          background: linear-gradient(135deg, rgba(34, 197, 94, 0.18), rgba(212, 160, 23, 0.95));
          box-shadow: 0 0 24px rgba(34, 197, 94, 0.1), 0 0 24px rgba(212, 160, 23, 0.1);
        }
        .ap-footer-link {
          position: relative;
          border-bottom-color: rgba(0, 224, 255, 0.08);
          color: rgba(244, 249, 248, 0.84);
          border-radius: 10px;
          padding: 12px 10px;
        }
        .ap-footer-link:hover {
          color: #00e0ff;
          background: rgba(0, 224, 255, 0.045);
          transform: translateX(3px);
        }
        .ap-section-label {
          color: rgba(255, 208, 84, 0.9);
          border-bottom-color: rgba(212, 160, 23, 0.16);
        }
        .ap-footer-icon {
          color: rgba(0, 224, 255, 0.46);
        }
        @keyframes ap-page-enter {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes ap-scan-line {
          0%, 100% { transform: translateX(-12%); opacity: 0; }
          25%, 70% { opacity: 0.9; }
          100% { transform: translateX(28%); }
        }
        @keyframes ap-orb-drift {
          from { transform: translate3d(0, 0, 0) scale(1); }
          to { transform: translate3d(-6vw, 4vh, 0) scale(1.08); }
        }
        @keyframes ap-primary-pulse {
          0%, 100% { filter: brightness(1); }
          50% { filter: brightness(1.12); }
        }
        /* Calendar specific styles */
        .follow-up-calendar-card {
          width: 100%;
          max-width: 100%;
          min-width: 0;
          overflow: hidden;
          padding: 22px;
        }
        .calendar-grid {
          display: grid;
          grid-template-columns: repeat(7, minmax(0, 1fr));
          gap: clamp(2px, 0.7vw, 4px);
          width: 100%;
          max-width: 100%;
          min-width: 0;
          margin: 16px 0 12px;
          overflow: hidden;
        }
        .calendar-weekday {
          min-width: 0;
          font-size: clamp(8px, 1.5vw, 10px);
          font-weight: 600;
          letter-spacing: 0.08em;
          color: #5a5040;
          text-align: center;
          padding: clamp(4px, 1.4vw, 8px) 0;
          overflow: hidden;
        }
        .calendar-day {
          min-width: 0;
          width: 100%;
          min-height: clamp(28px, 7vw, 46px);
          height: clamp(28px, 7vw, 46px);
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          background: #121212;
          border-radius: clamp(5px, 1.5vw, 8px);
          font-size: clamp(9px, 1.7vw, 11px);
          font-weight: 500;
          color: #a09070;
          cursor: pointer;
          transition: background 0.15s;
          border: 1px solid transparent;
          position: relative;
          overflow: hidden;
        }
        .calendar-day.current-month {
          color: #e8e0cc;
        }
        .calendar-day.other-month {
          color: #3a3520;
        }
        .calendar-day:hover {
          background: #202018;
          border-color: #3d3520;
        }
        .calendar-day.has-events {
          background: #1e1c10;
          border-color: #5a4a20;
        }
        .event-dot {
          width: 4px;
          height: 4px;
          background: #d4a017;
          border-radius: 50%;
          margin-top: 2px;
        }
        .event-count {
          font-size: clamp(7px, 1.4vw, 9px);
          color: #d4a017;
          margin-top: 2px;
        }
        .calendar-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 16px;
          min-width: 0;
          gap: 8px;
        }
        .calendar-nav-btn {
          background: #1c1c1c;
          border: 1px solid #2e2a18;
          border-radius: 6px;
          padding: clamp(5px, 1.5vw, 6px) clamp(7px, 2vw, 10px);
          display: flex;
          align-items: center;
          cursor: pointer;
          color: #c8b880;
          transition: all 0.15s;
          flex-shrink: 0;
        }
        .calendar-nav-btn:hover {
          border-color: #d4a017;
          background: #201e10;
        }
        .upcoming-item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 8px 0;
          border-bottom: 1px solid #1e1e1e;
          font-size: 12px;
        }
        .upcoming-item:last-child {
          border-bottom: none;
        }
        .upcoming-date {
          font-family: "Inter", "Manrope", Arial, sans-serif;
          font-size: 10px;
          color: #5a5040;
          margin-left: 8px;
        }
        .delete-btn {
          background: none;
          border: none;
          color: #5a5040;
          cursor: pointer;
          padding: 4px;
          border-radius: 4px;
          transition: all 0.15s;
          display: flex;
          align-items: center;
        }
        .delete-btn:hover {
          color: #d4a017;
          background: #2a2618;
        }
        .calendar-actions {
          display: flex;
          gap: 10px;
          margin-top: 8px;
          flex-wrap: wrap;
          max-width: 100%;
          min-width: 0;
          overflow: hidden;
        }
        .calendar-actions .ap-btn-outline,
        .calendar-actions .ap-btn-sm-gold {
          max-width: 100%;
          min-width: 0;
          justify-content: center;
        }
        @media (max-width: 420px) {
          .ap-max {
            padding-left: 14px;
            padding-right: 14px;
          }
          .follow-up-calendar-card {
            padding: 16px;
          }
          .calendar-grid {
            margin-top: 12px;
          }
          .calendar-actions {
            gap: 8px;
          }
          .calendar-actions .ap-btn-outline,
          .calendar-actions .ap-btn-sm-gold {
            padding: 8px 10px;
            font-size: 10px;
            letter-spacing: 0.06em;
          }
          .ap-meeting-visual {
            min-height: 72px;
          }
        }
        @media (prefers-reduced-motion: reduce) {
          .ap-card,
          .ap-tool-card,
          .ap-tool-icon,
          .ap-btn-outline,
          .ap-btn-sm-gold,
          .ap-join-btn,
          .ap-meeting-visual::before,
          .ap-meeting-visual::after,
          .ap-meeting-scan {
            animation: none !important;
            transition: none !important;
            transform: none !important;
          }
        }
        .home-command-page {
          position: relative;
          overflow-x: hidden;
          background:
            radial-gradient(circle at 14% 8%, rgba(0, 224, 255, 0.14), transparent 28%),
            radial-gradient(circle at 88% 18%, rgba(212, 160, 23, 0.12), transparent 28%),
            linear-gradient(145deg, #061014 0%, #0a151b 48%, #050609 100%) !important;
        }
        .home-command-page::before,
        .home-command-page::after {
          content: "";
          position: fixed;
          inset: 0;
          pointer-events: none;
          z-index: 0;
        }
        .home-command-page::before {
          opacity: 0.36;
          background-image:
            linear-gradient(rgba(75, 224, 255, 0.13) 1px, transparent 1px),
            linear-gradient(90deg, rgba(75, 224, 255, 0.13) 1px, transparent 1px);
          background-size: 44px 44px;
          mask-image: linear-gradient(to bottom, rgba(0,0,0,0.94), rgba(0,0,0,0.18));
          animation: ap-grid-drift-command 18s linear infinite;
        }
        .home-command-page::after {
          opacity: 0.24;
          background:
            linear-gradient(180deg, transparent 0%, rgba(0, 224, 255, 0.12) 48%, transparent 52%),
            radial-gradient(circle at 72% 76%, rgba(0, 224, 255, 0.18), transparent 24%);
          background-size: 100% 280px, 100% 100%;
          animation: ap-command-scan 8s ease-in-out infinite;
        }
        .ap-max {
          z-index: 1;
        }
        .ap-grid-3 {
          grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
          gap: 16px;
        }
        .ap-card,
        .ap-tool-card {
          animation: ap-card-stagger 560ms ease both;
        }
        .ap-tool-card:nth-child(1) { animation-delay: 80ms; }
        .ap-tool-card:nth-child(2) { animation-delay: 140ms; }
        .ap-tool-card:nth-child(3) { animation-delay: 200ms; }
        .ap-tool-card:nth-child(4) { animation-delay: 260ms; }
        .ap-tool-card:nth-child(5) { animation-delay: 320ms; }
        .ap-card::after,
        .ap-tool-card::after {
          content: "";
          position: absolute;
          inset: 0;
          pointer-events: none;
          background: linear-gradient(110deg, transparent 0%, rgba(255,255,255,0.08) 45%, transparent 62%);
          transform: translateX(-120%);
          transition: transform 0.72s ease;
        }
        .ap-card:hover::after,
        .ap-tool-card:hover::after {
          transform: translateX(120%);
        }
        .ap-card:hover,
        .ap-tool-card:hover {
          transform: translateY(-4px);
        }
        .ap-hero {
          min-height: auto !important;
          padding: clamp(28px, 4vw, 42px) clamp(20px, 4vw, 44px) !important;
          margin-bottom: 16px !important;
          text-align: center !important;
          align-items: center !important;
          justify-content: center !important;
          border-radius: 20px !important;
          border-color: rgba(0, 224, 255, 0.26) !important;
          background:
            linear-gradient(rgba(0, 224, 255, 0.08) 1px, transparent 1px),
            linear-gradient(90deg, rgba(0, 224, 255, 0.055) 1px, transparent 1px),
            radial-gradient(circle at 18% 15%, rgba(0, 224, 255, 0.2), transparent 34%),
            radial-gradient(circle at 88% 26%, rgba(212, 160, 23, 0.16), transparent 30%),
            linear-gradient(145deg, rgba(13, 24, 30, 0.84), rgba(5, 8, 11, 0.92)) !important;
          box-shadow: inset 0 1px 0 rgba(255,255,255,0.08), 0 24px 66px rgba(0,0,0,0.28), 0 0 34px rgba(0,224,255,0.08) !important;
          animation: ap-page-enter 520ms ease both, ap-hero-gradient 12s ease-in-out infinite;
          background-size: 44px 44px, 44px 44px, 140% 140%, 130% 130%, 100% 100% !important;
        }
        .ap-hero h1 {
          max-width: 980px;
          font-size: clamp(34px, 5vw, 54px) !important;
          font-weight: 800 !important;
          letter-spacing: 0.01em !important;
          color: #ffffff !important;
          margin: 0 0 8px !important;
          line-height: 1.02 !important;
          text-align: center !important;
        }
        .ap-hero p {
          max-width: 680px !important;
          margin: 0 0 24px !important;
          margin-left: auto !important;
          margin-right: auto !important;
          color: rgba(246, 252, 253, 0.9) !important;
          font-size: clamp(14px, 1.4vw, 16px) !important;
          line-height: 1.55 !important;
          letter-spacing: 0 !important;
          text-align: center !important;
        }
        .ap-tool-label,
        .ap-section-label,
        .ap-meeting-zone-title,
        .ap-live-badge,
        .calendar-weekday {
          letter-spacing: 0.06em !important;
        }
        .ap-join-btn,
        .ap-btn-gold,
        .ap-btn-outline,
        .ap-btn-sm-gold {
          letter-spacing: 0.04em !important;
          text-transform: none;
        }
        .ap-btn-gold {
          padding: 14px 28px !important;
          font-size: 14px !important;
          border-radius: 14px !important;
          color: #071014 !important;
          margin-left: auto;
          margin-right: auto;
        }
        .ap-meeting-zone {
          display: flex;
          flex-direction: column;
          gap: 14px;
          min-width: 0;
        }
        .ap-meeting-cards {
          display: grid;
          grid-template-columns: 1fr;
          gap: 14px;
          align-items: stretch;
        }
        .ap-meeting-zone-title {
          display: flex;
          align-items: center;
          gap: 10px;
          color: rgba(0, 224, 255, 0.8);
          font-family: "Inter", "Manrope", Arial, sans-serif;
          font-size: 11px;
          font-weight: 800;
          letter-spacing: 0.16em;
          text-transform: uppercase;
        }
        .ap-meeting-zone-title::before {
          content: "";
          width: 8px;
          height: 8px;
          border-radius: 999px;
          background: #22c55e;
          box-shadow: 0 0 16px rgba(34, 197, 94, 0.75);
          animation: pulse-dot 1.8s ease-in-out infinite;
        }
        .ap-meeting-card {
          border-color: rgba(0, 224, 255, 0.18);
          display: flex;
          flex-direction: column;
          min-width: 0;
        }
        .ap-meeting-card.primary {
          border-color: rgba(0, 224, 255, 0.34);
          box-shadow: inset 0 1px 0 rgba(255,255,255,0.07), 0 24px 58px rgba(0,0,0,0.28), 0 0 28px rgba(0,224,255,0.11);
        }
        .ap-meeting-card.secondary {
          border-color: rgba(212, 160, 23, 0.2);
        }
        .ap-meeting-card h2 {
          font-size: 21px !important;
          font-weight: 700 !important;
          letter-spacing: 0 !important;
          color: #ffffff !important;
        }
        .ap-meeting-id-box {
          padding: 14px !important;
        }
        .ap-meeting-label {
          font-size: 12px;
          color: rgba(0, 224, 255, 0.9);
          letter-spacing: 0.04em;
          margin-bottom: 6px;
          font-weight: 700;
        }
        .ap-meeting-value {
          font-size: 17px;
          font-weight: 700;
          color: #ffffff;
          letter-spacing: 0;
          line-height: 1.25;
        }
        .ap-meeting-note {
          font-size: 14px;
          color: rgba(242, 250, 251, 0.84);
          margin-bottom: 14px;
          line-height: 1.5;
        }
        .ap-live-badge {
          display: inline-flex;
          align-items: center;
          color: #22c55e;
          font-size: 11px;
          font-weight: 800;
          letter-spacing: 0.12em;
          text-transform: uppercase;
          animation: ap-live-badge-pulse 2.4s ease-in-out infinite;
        }
        .ap-meet-btn {
          border-color: rgba(0, 224, 255, 0.3);
          background: linear-gradient(135deg, rgba(0, 224, 255, 0.88), rgba(22, 119, 255, 0.88));
          color: #031015;
        }
        .ap-join-btn {
          color: #061017 !important;
          font-size: 13px !important;
          font-weight: 800 !important;
        }
        .ap-meet-btn:hover {
          box-shadow: 0 0 26px rgba(0, 224, 255, 0.24);
        }
        .ap-join-btn::before {
          content: "";
          position: absolute;
          inset: 0;
          background: linear-gradient(110deg, transparent, rgba(255,255,255,0.38), transparent);
          transform: translateX(-125%);
          transition: transform 0.72s ease;
        }
        .ap-join-btn:hover::before {
          transform: translateX(125%);
        }
        .ap-join-btn > * {
          position: relative;
          z-index: 1;
        }
        @keyframes ap-grid-drift-command {
          from { background-position: 0 0; }
          to { background-position: 44px 44px; }
        }
        @keyframes ap-command-scan {
          0%, 100% { background-position: 0 -280px, 0 0; }
          50% { background-position: 0 100vh, 0 0; }
        }
        @keyframes ap-card-stagger {
          from { opacity: 0; transform: translateY(14px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes ap-live-badge-pulse {
          0%, 100% { filter: brightness(1); text-shadow: 0 0 0 rgba(34, 197, 94, 0); }
          50% { filter: brightness(1.18); text-shadow: 0 0 16px rgba(34, 197, 94, 0.34); }
        }
        @keyframes ap-hero-gradient {
          0%, 100% { background-position: 0 0, 0 0, 50% 0%, 50% 90%, 0 0; }
          50% { background-position: 22px 22px, -18px 18px, 42% 10%, 58% 78%, 0 0; }
        }
        @media (max-width: 640px) {
          .ap-grid-3 {
            grid-template-columns: 1fr;
          }
          .ap-meeting-cards {
            grid-template-columns: 1fr;
          }
        }
      `}</style>

      <div className="ap-max">
        {/* Hero */}
        <div className="ap-hero">
          <h1
            style={{
              fontSize: "clamp(22px, 5vw, 32px)",
              fontWeight: 300,
              letterSpacing: "0.04em",
              color: "#f0e8d0",
              margin: "0 0 10px",
            }}
          >
            Agent Portal
          </h1>
          <p
            style={{
              fontSize: "13px",
              color: "#7a6a50",
              margin: "0 0 32px",
              maxWidth: "380px",
              marginLeft: "auto",
              marginRight: "auto",
              lineHeight: 1.6,
            }}
          >
            Your secure operations hub for carrier access, sales submissions,
            scripts, resources, meetings, and agency communication.
          </p>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <button
              onClick={() =>
                window.open("https://submit.ffldiligence.com/", "_blank")
              }
              className="ap-btn-gold"
            >
              SUBMIT SALE
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polyline points="9 18 15 12 9 6" />
              </svg>
            </button>
          </div>
        </div>

        {/* Tool Cards */}
        <div className="ap-grid-3">
          {tools.map((t) => (
            <div
              key={t.label}
              className="ap-tool-card"
              onClick={() => t.link && navigate(t.link)}
            >
              <div className="ap-tool-icon">{t.icon}</div>
              <span className="ap-tool-label">{t.label}</span>
            </div>
          ))}
        </div>

        {/* Mid: Follow-up + Meeting */}
        <div className="ap-mid-grid">
          {/* Follow-up Calendar with actual calendar */}
          <div className="ap-card follow-up-calendar-card">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                marginBottom: "20px",
              }}
            >
              <span style={{ color: "#d4a017", opacity: 0.7 }}>
                <CalIcon />
              </span>
              <span
                style={{
                  fontSize: "11px",
                  fontWeight: 700,
                  letterSpacing: "0.14em",
                  color: "#8a7a50",
                }}
              >
                TACTICAL SCHEDULING GRID
              </span>
            </div>
            
            {/* Calendar Header */}
            <div className="calendar-header">
              <button className="calendar-nav-btn" onClick={prevMonth}>
                <ChevronLeftIcon />
              </button>
              <span style={{ fontSize: "14px", fontWeight: 500, color: "#e8e0cc" }}>
                {monthNames[month]} {year}
              </span>
              <button className="calendar-nav-btn" onClick={nextMonth}>
                <ChevronRightIcon />
              </button>
            </div>
            
            {/* Calendar Grid */}
            <div className="calendar-grid">
              {weekDays.map(day => (
                <div key={day} className="calendar-weekday">{day}</div>
              ))}
              {calendarDays.map((day, idx) => {
                const followUpsForDay = getFollowUpsForDate(day.date, day.isCurrentMonth);
                const hasEvents = followUpsForDay.length > 0;
                const dateDisplay = day.date;
                return (
                  <div 
                    key={idx}
                    className={`calendar-day ${day.isCurrentMonth ? 'current-month' : 'other-month'} ${hasEvents ? 'has-events' : ''}`}
                  >
                    <span>{dateDisplay}</span>
                    {hasEvents && (
                      <span className="event-count">{followUpsForDay.length}</span>
                    )}
                  </div>
                );
              })}
            </div>
            
            {/* Upcoming Follow-ups List */}
            {upcomingFollowUps.length > 0 && (
              <div style={{ marginTop: "20px", marginBottom: "16px" }}>
                <div style={{ fontSize: "10px", fontWeight: 600, letterSpacing: "0.1em", color: "#5a5040", marginBottom: "12px" }}>
                  UPCOMING FOLLOW-UPS
                </div>
                {upcomingFollowUps.map(f => {
                  const displayDate = new Date(f.date).toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
                  return (
                    <div key={f.id} className="upcoming-item">
                      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        <span style={{ fontSize: "12px", color: "#c8b880" }}>{f.name}</span>
                        <span className="upcoming-date">{displayDate}</span>
                      </div>
                      <button className="delete-btn" onClick={() => deleteFollowUp(f.id)}>
                        <TrashIcon />
                      </button>
                    </div>
                  );
                })}
              </div>
            )}
            
            {upcomingFollowUps.length === 0 && (
              <div style={{ textAlign: "center", padding: "20px 0", color: "#5a5040", fontSize: "12px" }}>
                No follow-ups scheduled
              </div>
            )}
            
            {/* Action Buttons */}
            <div className="calendar-actions">
              <button className="ap-btn-outline" onClick={() => window.open("https://calendar.google.com", "_blank")}>
                OPEN GOOGLE CALENDAR
                <ExtIcon />
              </button>
              <button
                className="ap-btn-sm-gold"
                onClick={() => setAddFollowUp((f) => !f)}
              >
                ADD FOLLOW-UP
                <svg
                  width="13"
                  height="13"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                >
                  <line x1="12" y1="5" x2="12" y2="19" />
                  <line x1="5" y1="12" x2="19" y2="12" />
                </svg>
              </button>
            </div>
            
            {/* Add Follow-up Form */}
            {addFollowUp && (
              <div
                style={{
                  marginTop: "14px",
                  background: "#1a1810",
                  border: "1px solid #2a2618",
                  borderRadius: "8px",
                  padding: "14px",
                  display: "flex",
                  flexDirection: "column",
                  gap: "8px",
                }}
              >
                <input
                  placeholder="Contact name"
                  value={newFollowUpName}
                  onChange={(e) => setNewFollowUpName(e.target.value)}
                  style={{
                    background: "#0e0e0e",
                    border: "1px solid #2a2618",
                    borderRadius: "6px",
                    padding: "8px 12px",
                    color: "#e8e0cc",
                    fontSize: "12px",
                    fontFamily: "inherit",
                    outline: "none",
                  }}
                />
                <input
                  type="date"
                  value={newFollowUpDate}
                  onChange={(e) => setNewFollowUpDate(e.target.value)}
                  style={{
                    background: "#0e0e0e",
                    border: "1px solid #2a2618",
                    borderRadius: "6px",
                    padding: "8px 12px",
                    color: "#e8e0cc",
                    fontSize: "12px",
                    fontFamily: "inherit",
                    outline: "none",
                    colorScheme: "dark",
                  }}
                />
                <div style={{ display: "flex", gap: "8px", justifyContent: "flex-end" }}>
                  <button
                    className="ap-btn-outline"
                    style={{ padding: "6px 12px" }}
                    onClick={() => setAddFollowUp(false)}
                  >
                    Cancel
                  </button>
                  <button
                    className="ap-btn-sm-gold"
                    onClick={addNewFollowUp}
                  >
                    Save
                  </button>
                </div>
              </div>
            )}
          </div>

          {/* Meeting Center */}
          <div className="ap-meeting-zone">
            <div className="ap-meeting-zone-title">LIVE MEETING CENTER</div>

            <div className="ap-meeting-cards">
              <div className="ap-card ap-meeting-card primary" style={{ padding: "22px" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "space-between",
                    marginBottom: "10px",
                  }}
                >
                  <div>
                    <h2
                      style={{
                        fontSize: "18px",
                        fontWeight: 400,
                        color: "#f0e8d0",
                        margin: "0 0 8px",
                        lineHeight: 1.3,
                      }}
                    >
                      Luminex Meeting Room
                    </h2>
                    <div className="ap-live-badge">
                      <span className="ap-live-dot" />
                      Google Meet
                    </div>
                  </div>
                  <div
                    onClick={openDailyConnect}
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        openDailyConnect();
                      }
                    }}
                    style={{
                      width: "38px",
                      height: "38px",
                      background: "rgba(0, 224, 255, 0.08)",
                      border: "1px solid rgba(0, 224, 255, 0.24)",
                      borderRadius: "12px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#00e0ff",
                      flexShrink: 0,
                      cursor: "pointer",
                    }}
                  >
                    <VideoIcon />
                  </div>
                </div>

                <div className="ap-meeting-id-box">
                  <div>
                    <div className="ap-meeting-label">
                      PLATFORM
                    </div>
                    <div className="ap-mono ap-meeting-value">
                      Google Meet
                    </div>
                  </div>
                  <div>
                    <div className="ap-meeting-label">
                      ACCESS
                    </div>
                    <div className="ap-mono ap-meeting-value">
                      Meeting Room
                    </div>
                  </div>
                </div>

                <div className="ap-meeting-note">
                  Secure video room for Luminex team meetings.
                </div>

                <button className="ap-join-btn ap-meet-btn" onClick={openDailyConnect}>
                  <span>Join Luminex Meeting Room</span>
                  <ExtIcon />
                </button>
              </div>

              <div className="ap-card ap-meeting-card secondary" style={{ padding: "22px" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "space-between",
                    marginBottom: "10px",
                  }}
                >
                  <div>
                    <h2
                      style={{
                        fontSize: "18px",
                        fontWeight: 400,
                        color: "#f0e8d0",
                        margin: "0 0 8px",
                        lineHeight: 1.3,
                      }}
                    >
                      Weekly Team Meeting
                    </h2>
                    <div className="ap-live-badge">
                      <span className="ap-live-dot" />
                      Zoom
                    </div>
                  </div>
                  <div
                    onClick={openZoomMeeting}
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        openZoomMeeting();
                      }
                    }}
                    style={{
                      width: "38px",
                      height: "38px",
                      background: "rgba(0, 224, 255, 0.08)",
                      border: "1px solid rgba(0, 224, 255, 0.24)",
                      borderRadius: "12px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#00e0ff",
                      flexShrink: 0,
                      cursor: "pointer",
                    }}
                  >
                    <VideoIcon />
                  </div>
                </div>

                <div className="ap-meeting-id-box">
                  <div>
                    <div className="ap-meeting-label">
                      SCHEDULE
                    </div>
                    <div className="ap-mono ap-meeting-value">
                      Thursday 7PM EST
                    </div>
                  </div>
                  <div>
                    <div className="ap-meeting-label">
                      MEETING ID
                    </div>
                    <div className="ap-mono ap-meeting-value">
                      530 570 5567
                    </div>
                  </div>
                </div>

                <div className="ap-meeting-note">
                  Passcode: <span className="ap-mono" style={{ color: "#e8e0cc", fontWeight: 700 }}>wintheday</span>
                </div>

                <button className="ap-join-btn" onClick={openZoomMeeting}>
                  <span>Join Zoom Meeting</span>
                  <ExtIcon />
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Footer Links */}
        <div className="ap-card ap-toolkit-card" style={{ padding: "22px 28px" }}>
          <div className="ap-footer-grid">
            {/* Agency Platforms */}
            <div>
              <div className="ap-section-label">AGENCY PLATFORMS</div>
              {agencyPlatforms.map((p) => (
                <div
                  key={p.label}
                  className="ap-footer-link"
                  onClick={() => {
                    if (p.link) {
                      window.open(p.link, "_blank");
                    }

                    if (p.pdf) {
                      window.open(p.pdf, "_blank");
                    }
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <span className="ap-footer-icon">
                      <svg
                        width="14"
                        height="14"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                      >
                        <rect x="3" y="3" width="18" height="18" rx="2" />
                        <line x1="9" y1="9" x2="15" y2="9" />
                        <line x1="9" y1="12" x2="15" y2="12" />
                        <line x1="9" y1="15" x2="12" y2="15" />
                      </svg>
                    </span>
                    <span>{p.label}</span>
                  </div>

                  <span style={{ color: "#3a3020", flexShrink: 0 }}>
                    <ExtIcon />
                  </span>
                </div>
              ))}
            </div>

            {/* Agent Access */}
            <div>
              <div className="ap-section-label">AGENT ACCESS</div>
              {agentAccess.map((p) => (
                <div key={p.label}>
                  {p.hasDropdown ? (
                    <div className="ap-relative" ref={toolkitRef}>
                      <div className="ap-footer-link" onClick={handleToolkitClick}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                          }}
                        >
                          <span className="ap-footer-icon">
                            <svg
                              width="14"
                              height="14"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                            >
                              <rect x="3" y="11" width="18" height="11" rx="2" />
                              <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                            </svg>
                          </span>
                          <span>{p.label}</span>
                        </div>
                        <span style={{ color: "#3a3020", flexShrink: 0 }}>
                          <ChevronIcon isOpen={openToolkit} />
                        </span>
                      </div>
                      {openToolkit && (
                        <div className="ap-dropdown">
                          {p.options && p.options.map((opt) => (
                            <div
                              key={opt.label}
                              className="ap-dropdown-item"
                              onClick={() => handleOptionClick(opt.link)}
                            >
                              <span>{opt.label}</span>
                              <ExtIcon />
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  ) : (
                    <div
                      className="ap-footer-link"
                      onClick={() => {
                        if (p.link) {
                          window.open(p.link, "_blank");
                        }
                        if (p.pdf) {
                          window.open(p.pdf, "_blank");
                        }
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                      >
                        <span className="ap-footer-icon">
                          <svg
                            width="14"
                            height="14"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                          >
                            <rect x="3" y="11" width="18" height="11" rx="2" />
                            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                          </svg>
                        </span>
                        <span>{p.label}</span>
                      </div>
                      <span style={{ color: "#3a3020", flexShrink: 0 }}>
                        {p.hasExt ? <ExtIcon /> : <ChevronIcon isOpen={false} />}
                      </span>
                    </div>
                  )}
                </div>
              ))}
            </div>

            {/* Operations */}
            <div>
              <div className="ap-section-label">OPERATIONS</div>
              {operations.map((p) => (
                <div
                  onClick={() => {
                    if (p.link) {
                      window.open(p.link, "_blank");
                    }

                    if (p.pdf) {
                      window.open(p.pdf, "_blank");
                    }
                  }}
                  key={p.label}
                  className="ap-footer-link"
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <span className="ap-footer-icon">{p.icon}</span>
                    <span>{p.label}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}






// import { useState, useRef, useEffect } from "react";
// import { useNavigate } from "react-router-dom";

// const KeyIcon = () => (
//   <svg
//     width="22"
//     height="22"
//     viewBox="0 0 24 24"
//     fill="none"
//     stroke="currentColor"
//     strokeWidth="1.5"
//     strokeLinecap="round"
//     strokeLinejoin="round"
//   >
//     <circle cx="8" cy="15" r="4" />
//     <line x1="11" y1="12" x2="21" y2="2" />
//     <line x1="18" y1="5" x2="21" y2="8" />
//   </svg>
// );
// const ScriptIcon = () => (
//   <svg
//     width="22"
//     height="22"
//     viewBox="0 0 24 24"
//     fill="none"
//     stroke="currentColor"
//     strokeWidth="1.5"
//     strokeLinecap="round"
//     strokeLinejoin="round"
//   >
//     <rect x="3" y="3" width="18" height="18" rx="2" />
//     <line x1="7" y1="8" x2="17" y2="8" />
//     <line x1="7" y1="12" x2="17" y2="12" />
//     <line x1="7" y1="16" x2="12" y2="16" />
//   </svg>
// );
// const ContactIcon = () => (
//   <svg
//     width="22"
//     height="22"
//     viewBox="0 0 24 24"
//     fill="none"
//     stroke="currentColor"
//     strokeWidth="1.5"
//     strokeLinecap="round"
//     strokeLinejoin="round"
//   >
//     <rect x="3" y="3" width="18" height="18" rx="2" />
//     <circle cx="12" cy="10" r="3" />
//     <path d="M6 21v-1a6 6 0 0 1 12 0v1" />
//   </svg>
// );
// const CalIcon = () => (
//   <svg
//     width="16"
//     height="16"
//     viewBox="0 0 24 24"
//     fill="none"
//     stroke="currentColor"
//     strokeWidth="1.5"
//     strokeLinecap="round"
//     strokeLinejoin="round"
//   >
//     <rect x="3" y="4" width="18" height="18" rx="2" />
//     <line x1="16" y1="2" x2="16" y2="6" />
//     <line x1="8" y1="2" x2="8" y2="6" />
//     <line x1="3" y1="10" x2="21" y2="10" />
//   </svg>
// );
// const VideoIcon = () => (
//   <svg
//     width="18"
//     height="18"
//     viewBox="0 0 24 24"
//     fill="none"
//     stroke="currentColor"
//     strokeWidth="1.5"
//     strokeLinecap="round"
//     strokeLinejoin="round"
//   >
//     <polygon points="23 7 16 12 23 17 23 7" />
//     <rect x="1" y="5" width="15" height="14" rx="2" />
//   </svg>
// );
// const ExtIcon = () => (
//   <svg
//     width="13"
//     height="13"
//     viewBox="0 0 24 24"
//     fill="none"
//     stroke="currentColor"
//     strokeWidth="2"
//     strokeLinecap="round"
//     strokeLinejoin="round"
//   >
//     <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
//     <polyline points="15 3 21 3 21 9" />
//     <line x1="10" y1="14" x2="21" y2="3" />
//   </svg>
// );
// const ChevronIcon = ({ isOpen = false }) => (
//   <svg
//     width="14"
//     height="14"
//     viewBox="0 0 24 24"
//     fill="none"
//     stroke="currentColor"
//     strokeWidth="2"
//     strokeLinecap="round"
//     strokeLinejoin="round"
//     style={{ transform: isOpen ? "rotate(180deg)" : "rotate(0deg)", transition: "transform 0.2s" }}
//   >
//     <polyline points="6 9 12 15 18 9" />
//   </svg>
// );
// const CalEmptyIcon = () => (
//   <svg
//     width="40"
//     height="40"
//     viewBox="0 0 24 24"
//     fill="none"
//     stroke="currentColor"
//     strokeWidth="1"
//     strokeLinecap="round"
//     strokeLinejoin="round"
//     style={{ opacity: 0.25 }}
//   >
//     <rect x="3" y="4" width="18" height="18" rx="2" />
//     <line x1="16" y1="2" x2="16" y2="6" />
//     <line x1="8" y1="2" x2="8" y2="6" />
//     <line x1="3" y1="10" x2="21" y2="10" />
//   </svg>
// );

// const tools = [
//   { icon: <KeyIcon />, label: "CARRIER LOGINS", link: "/carrier-login" },
//   { icon: <ScriptIcon />, label: "SCRIPTS", link: "/scripts" },
//   { icon: <ContactIcon />, label: "CARRIER CONTACTS" },
// ];

// const agencyPlatforms = [
//   { label: "HCMS", link: "https://hcms.chims.uppatop.com/login" },
//   { label: "Bonus Structure", pdf: "/Bonus-structure.pdf" },
//   {
//     label: "IP Leaderboard",
//     link: "https://ww3.familyfirstlife.com/dashboard#",
//   },
// ];

// const agentAccess = [
//   { 
//     label: "Carrier Toolkit", 
//     hasDropdown: true,
//     options: [
//       { label: "FEX Toolkit", link: "https://app.insurancetoolkits.com/" },
//       { label: "Integrity Toolkit", link: "https://connect.integrity.com/agent/dashboard?quick-quote-initiated=true" }
//     ]
//   },
//   { label: "CRM Access", hasExt: true, link: "https://clydios.com/login" },
// ];

// const operations = [
//   { label: "Time Off", icon: <CalIcon /> },
//   {
//     label: "Update Info",
//     icon: (
//       <svg
//         width="16"
//         height="16"
//         viewBox="0 0 24 24"
//         fill="none"
//         stroke="currentColor"
//         strokeWidth="1.5"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//       >
//         <circle cx="12" cy="8" r="4" />
//         <path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" />
//       </svg>
//     ),
//   },
//   {
//     label: "Hiring Portal",
//     icon: (
//       <svg
//         width="16"
//         height="16"
//         viewBox="0 0 24 24"
//         fill="none"
//         stroke="currentColor"
//         strokeWidth="1.5"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//       >
//         <circle cx="9" cy="8" r="4" />
//         <path d="M3 20c0-4 2.7-7 6-7s6 3 6 7" />
//         <path d="M16 11l2 2 4-4" />
//       </svg>
//     ),
//     link: "https://form.jotform.com/260434781561155",
//   },
// ];

// export default function Home() {
//   const [addFollowUp, setAddFollowUp] = useState(false);
//   const [openToolkit, setOpenToolkit] = useState(false);
//   const navigate = useNavigate();
//   const toolkitRef = useRef(null);

//   // Close dropdown when clicking outside
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (toolkitRef.current && !toolkitRef.current.contains(event.target)) {
//         setOpenToolkit(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   const handleToolkitClick = () => {
//     setOpenToolkit(!openToolkit);
//   };

//   const handleOptionClick = (link) => {
//     window.open(link, "_blank");
//     setOpenToolkit(false);
//   };

//   return (
//     <div
//       style={{
//         minHeight: "100vh",
//         backgroundColor: "#0e0e0e",
//         color: "#e8e0cc",
//         fontFamily: "'DM Sans', 'Helvetica Neue', Arial, sans-serif",
//         padding: "24px 20px",
//         boxSizing: "border-box",
//       }}
//     >
//       <style>{`
//         @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600&family=DM+Mono:wght@400;500&display=swap');
//         * { box-sizing: border-box; }
//         .ap-btn-gold {
//           background: #d4a017;
//           color: #0e0e0e;
//           border: none;
//           padding: 14px 32px;
//           font-size: 13px;
//           font-weight: 600;
//           letter-spacing: 0.12em;
//           cursor: pointer;
//           border-radius: 6px;
//           display: flex; align-items: center; gap: 10px;
//           transition: background 0.18s, transform 0.12s;
//           font-family: inherit;
//         }
//         .ap-btn-gold:hover { background: #e5b420; transform: translateY(-1px); }
//         .ap-btn-gold:active { transform: translateY(0); }
//         .ap-card {
//           background: #161616;
//           border: 1px solid #2a2618;
//           border-radius: 14px;
//           transition: border-color 0.2s;
//         }
//         .ap-card:hover { border-color: #3d3520; }
//         .ap-tool-card {
//           background: #161616;
//           border: 1px solid #2a2618;
//           border-radius: 14px;
//           display: flex; flex-direction: column;
//           align-items: center; justify-content: center;
//           gap: 14px;
//           padding: 32px 16px;
//           cursor: pointer;
//           transition: border-color 0.2s, background 0.2s;
//           min-height: 130px;
//         }
//         .ap-tool-card:hover { border-color: #d4a017; background: #1c1a10; }
//         .ap-tool-icon {
//           width: 44px; height: 44px;
//           background: #1e1c10;
//           border-radius: 10px;
//           display: flex; align-items: center; justify-content: center;
//           color: #d4a017;
//           border: 1px solid #2e2a10;
//         }
//         .ap-tool-label {
//           font-size: 11px;
//           font-weight: 600;
//           letter-spacing: 0.1em;
//           color: #a09070;
//         }
//         .ap-btn-outline {
//           background: #1c1c1c;
//           color: #c8b880;
//           border: 1px solid #2e2a18;
//           padding: 9px 14px;
//           font-size: 11px;
//           font-weight: 600;
//           letter-spacing: 0.08em;
//           cursor: pointer;
//           border-radius: 7px;
//           display: flex; align-items: center; gap: 7px;
//           transition: border-color 0.18s, background 0.18s;
//           font-family: inherit;
//           white-space: nowrap;
//         }
//         .ap-btn-outline:hover { border-color: #d4a017; background: #201e10; }
//         .ap-btn-sm-gold {
//           background: #2a2310;
//           color: #d4a017;
//           border: 1px solid #3a3010;
//           padding: 9px 14px;
//           font-size: 11px;
//           font-weight: 600;
//           letter-spacing: 0.08em;
//           cursor: pointer;
//           border-radius: 7px;
//           display: flex; align-items: center; gap: 6px;
//           transition: background 0.18s;
//           font-family: inherit;
//           white-space: nowrap;
//         }
//         .ap-btn-sm-gold:hover { background: #352c12; }
//         .ap-join-btn {
//           background: #d4a017;
//           color: #0e0e0e;
//           border: none;
//           padding: 16px 24px;
//           font-size: 12px;
//           font-weight: 700;
//           letter-spacing: 0.14em;
//           cursor: pointer;
//           border-radius: 8px;
//           display: flex; align-items: center; justify-content: center; gap: 8px;
//           width: 100%;
//           transition: background 0.18s;
//           font-family: inherit;
//         }
//         .ap-join-btn:hover { background: #e5b420; }
//         .ap-footer-link {
//           display: flex; align-items: center; justify-content: space-between;
//           padding: 14px 0;
//           border-bottom: 1px solid #1e1e1e;
//           color: #c8b880;
//           font-size: 13px;
//           cursor: pointer;
//           transition: color 0.15s;
//           gap: 8px;
//         }
//         .ap-footer-link:last-child { border-bottom: none; }
//         .ap-footer-link:hover { color: #d4a017; }
//         .ap-footer-icon { color: #5a5040; flex-shrink: 0; }
//         .ap-section-label {
//           font-size: 10px;
//           font-weight: 700;
//           letter-spacing: 0.18em;
//           color: #5a5040;
//           margin-bottom: 12px;
//           border-bottom: 1px solid #1e1c14;
//           padding-bottom: 8px;
//         }
//         .ap-hero {
//           background: #141410;
//           border: 1px solid #2a2618;
//           border-radius: 18px;
//           padding: 48px 32px;
//           text-align: center;
//           position: relative;
//           overflow: hidden;
//           margin-bottom: 20px;
//         }
//         .ap-hero::before {
//           content: '';
//           position: absolute;
//           top: -60px; left: 50%; transform: translateX(-50%);
//           width: 300px; height: 200px;
//           background: radial-gradient(ellipse, rgba(212,160,23,0.08) 0%, transparent 70%);
//           pointer-events: none;
//         }
//         .ap-grid-3 {
//           display: grid;
//           grid-template-columns: repeat(3, 1fr);
//           gap: 14px;
//           margin-bottom: 20px;
//         }
//         @media (max-width: 640px) {
//           .ap-grid-3 { grid-template-columns: repeat(3, 1fr); }
//         }
//         @media (max-width: 400px) {
//           .ap-grid-3 { grid-template-columns: repeat(1, 1fr); gap: 10px; }
//         }
//         .ap-mid-grid {
//           display: grid;
//           grid-template-columns: 1fr 1fr;
//           gap: 14px;
//           margin-bottom: 20px;
//         }
//         @media (max-width: 640px) {
//           .ap-mid-grid { grid-template-columns: 1fr; }
//         }
//         .ap-footer-grid {
//           display: grid;
//           grid-template-columns: repeat(3, 1fr);
//           gap: 20px;
//         }
//         @media (max-width: 640px) {
//           .ap-footer-grid { grid-template-columns: 1fr; gap: 8px; }
//         }
//         .ap-meeting-id-box {
//           background: #1a1810;
//           border: 1px solid #2a2618;
//           border-radius: 10px;
//           padding: 16px;
//           display: grid;
//           grid-template-columns: 1fr 1fr;
//           gap: 12px;
//           margin-bottom: 16px;
//         }
//         .ap-mono { font-family: 'DM Mono', monospace; }
//         .ap-live-dot {
//           width: 7px; height: 7px;
//           background: #22c55e;
//           border-radius: 50%;
//           display: inline-block;
//           margin-right: 6px;
//           animation: pulse-dot 2s ease-in-out infinite;
//         }
//         @keyframes pulse-dot {
//           0%, 100% { opacity: 1; }
//           50% { opacity: 0.4; }
//         }
//         .ap-max {
//           max-width: 100%;
//           margin: 0 auto;
//         }
//         .ap-report-link {
//           font-size: 11px;
//           color: #5a5040;
//           letter-spacing: 0.1em;
//           cursor: pointer;
//           text-decoration: underline;
//           text-underline-offset: 3px;
//           transition: color 0.15s;
//         }
//         .ap-report-link:hover { color: #d4a017; }
//         .ap-dropdown {
//           position: absolute;
//           top: 100%;
//           left: 0;
//           right: 0;
//           background: #1a1810;
//           border: 1px solid #2e2a18;
//           border-radius: 8px;
//           margin-top: 4px;
//           z-index: 10;
//           box-shadow: 0 8px 16px rgba(0,0,0,0.4);
//           overflow: hidden;
//         }
//         .ap-dropdown-item {
//           padding: 12px 16px;
//           font-size: 12px;
//           color: #c8b880;
//           cursor: pointer;
//           transition: background 0.15s, color 0.15s;
//           border-bottom: 1px solid #2a2618;
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//         }
//         .ap-dropdown-item:last-child {
//           border-bottom: none;
//         }
//         .ap-dropdown-item:hover {
//           background: #25220e;
//           color: #d4a017;
//         }
//         .ap-relative {
//           position: relative;
//         }
//       `}</style>

//       <div className="ap-max">
//         {/* Hero */}
//         <div className="ap-hero">
//           <h1
//             style={{
//               fontSize: "clamp(22px, 5vw, 32px)",
//               fontWeight: 300,
//               letterSpacing: "0.04em",
//               color: "#f0e8d0",
//               margin: "0 0 10px",
//             }}
//           >
//             Agent Portal Active
//           </h1>
//           <p
//             style={{
//               fontSize: "13px",
//               color: "#7a6a50",
//               margin: "0 0 32px",
//               maxWidth: "380px",
//               marginLeft: "auto",
//               marginRight: "auto",
//               lineHeight: 1.6,
//             }}
//           >
//             Secure terminal for submitting sales, accessing carrier tools, and
//             managing agency documents.
//           </p>
//           <div
//             style={{
//               display: "flex",
//               flexDirection: "column",
//               alignItems: "center",
//               gap: "12px",
//             }}
//           >
//             <button
//               onClick={() =>
//                 window.open("https://diligence-agencies.netlify.app/", "_blank")
//               }
//               className="ap-btn-gold"
//             >
//               SUBMIT SALE
//               <svg
//                 width="16"
//                 height="16"
//                 viewBox="0 0 24 24"
//                 fill="none"
//                 stroke="currentColor"
//                 strokeWidth="2.5"
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//               >
//                 <polyline points="9 18 15 12 9 6" />
//               </svg>
//             </button>
//           </div>
//         </div>

//         {/* Tool Cards */}
//         <div className="ap-grid-3">
//           {tools.map((t) => (
//             <div
//               key={t.label}
//               className="ap-tool-card"
//               onClick={() => t.link && navigate(t.link)}
//             >
//               <div className="ap-tool-icon">{t.icon}</div>
//               <span className="ap-tool-label">{t.label}</span>
//             </div>
//           ))}
//         </div>

//         {/* Mid: Follow-up + Meeting */}
//         <div className="ap-mid-grid">
//           {/* Follow-up Calendar */}
//           <div className="ap-card" style={{ padding: "22px" }}>
//             <div
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 gap: "8px",
//                 marginBottom: "20px",
//               }}
//             >
//               <span style={{ color: "#d4a017", opacity: 0.7 }}>
//                 <CalIcon />
//               </span>
//               <span
//                 style={{
//                   fontSize: "11px",
//                   fontWeight: 700,
//                   letterSpacing: "0.14em",
//                   color: "#8a7a50",
//                 }}
//               >
//                 FOLLOW-UP CALENDAR
//               </span>
//             </div>
//             <div
//               style={{
//                 display: "flex",
//                 flexDirection: "column",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 padding: "24px 0",
//                 gap: "10px",
//               }}
//             >
//               <CalEmptyIcon />
//               <p
//                 style={{
//                   fontSize: "12px",
//                   color: "#5a5040",
//                   margin: 0,
//                   textAlign: "center",
//                 }}
//               >
//                 No follow-ups scheduled today
//               </p>
//             </div>
//             <div
//               style={{
//                 display: "flex",
//                 gap: "10px",
//                 marginTop: "8px",
//                 flexWrap: "wrap",
//               }}
//             >
//               <button className="ap-btn-outline">
//                 OPEN GOOGLE CALENDAR
//                 <ExtIcon />
//               </button>
//               <button
//                 className="ap-btn-sm-gold"
//                 onClick={() => setAddFollowUp((f) => !f)}
//               >
//                 ADD FOLLOW-UP
//                 <svg
//                   width="13"
//                   height="13"
//                   viewBox="0 0 24 24"
//                   fill="none"
//                   stroke="currentColor"
//                   strokeWidth="2.5"
//                   strokeLinecap="round"
//                 >
//                   <line x1="12" y1="5" x2="12" y2="19" />
//                   <line x1="5" y1="12" x2="19" y2="12" />
//                 </svg>
//               </button>
//             </div>
//             {addFollowUp && (
//               <div
//                 style={{
//                   marginTop: "14px",
//                   background: "#1a1810",
//                   border: "1px solid #2a2618",
//                   borderRadius: "8px",
//                   padding: "14px",
//                   display: "flex",
//                   flexDirection: "column",
//                   gap: "8px",
//                 }}
//               >
//                 <input
//                   placeholder="Contact name"
//                   style={{
//                     background: "#0e0e0e",
//                     border: "1px solid #2a2618",
//                     borderRadius: "6px",
//                     padding: "8px 12px",
//                     color: "#e8e0cc",
//                     fontSize: "12px",
//                     fontFamily: "inherit",
//                     outline: "none",
//                   }}
//                 />
//                 <input
//                   type="date"
//                   style={{
//                     background: "#0e0e0e",
//                     border: "1px solid #2a2618",
//                     borderRadius: "6px",
//                     padding: "8px 12px",
//                     color: "#e8e0cc",
//                     fontSize: "12px",
//                     fontFamily: "inherit",
//                     outline: "none",
//                     colorScheme: "dark",
//                   }}
//                 />
//                 <button
//                   className="ap-btn-sm-gold"
//                   style={{ alignSelf: "flex-end" }}
//                 >
//                   Save
//                 </button>
//               </div>
//             )}
//           </div>

//           {/* Agency Meeting */}
//           <div className="ap-card" style={{ padding: "22px" }}>
//             <div
//               style={{
//                 display: "flex",
//                 alignItems: "flex-start",
//                 justifyContent: "space-between",
//                 marginBottom: "10px",
//               }}
//             >
//               <div>
//                 <h2
//                   style={{
//                     fontSize: "18px",
//                     fontWeight: 400,
//                     color: "#f0e8d0",
//                     margin: "0 0 8px",
//                     lineHeight: 1.3,
//                   }}
//                 >
//                   Agency Strategy Meeting
//                 </h2>
//                 <div
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     fontSize: "10px",
//                     fontWeight: 700,
//                     letterSpacing: "0.12em",
//                     color: "#22c55e",
//                   }}
//                 >
//                   <span className="ap-live-dot" />
//                   LIVE ON: EVERY THURSDAY @ 7PM EST
//                 </div>
//               </div>
//               <div
//                 style={{
//                   width: "38px",
//                   height: "38px",
//                   background: "#1e1c10",
//                   border: "1px solid #2e2a10",
//                   borderRadius: "8px",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   color: "#d4a017",
//                   flexShrink: 0,
//                 }}
//               >
//                 <VideoIcon />
//               </div>
//             </div>

//             <div className="ap-meeting-id-box">
//               <div>
//                 <div
//                   style={{
//                     fontSize: "10px",
//                     color: "#5a5040",
//                     letterSpacing: "0.12em",
//                     marginBottom: "6px",
//                   }}
//                 >
//                   MEETING ID
//                 </div>
//                 <div
//                   className="ap-mono"
//                   style={{
//                     fontSize: "17px",
//                     fontWeight: 500,
//                     color: "#e8e0cc",
//                     letterSpacing: "0.05em",
//                   }}
//                 >
//                   530 570 5567
//                 </div>
//               </div>
//               <div>
//                 <div
//                   style={{
//                     fontSize: "10px",
//                     color: "#5a5040",
//                     letterSpacing: "0.12em",
//                     marginBottom: "6px",
//                   }}
//                 >
//                   PASSCODE
//                 </div>
//                 <div
//                   className="ap-mono"
//                   style={{
//                     fontSize: "17px",
//                     fontWeight: 500,
//                     color: "#e8e0cc",
//                   }}
//                 >
//                   wintheday
//                 </div>
//               </div>
//             </div>

//             <button className="ap-join-btn">
//               JOIN ZOOM MEETING
//               <svg
//                 width="14"
//                 height="14"
//                 viewBox="0 0 24 24"
//                 fill="none"
//                 stroke="currentColor"
//                 strokeWidth="2.5"
//                 strokeLinecap="round"
//               >
//                 <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
//                 <polyline points="15 3 21 3 21 9" />
//                 <line x1="10" y1="14" x2="21" y2="3" />
//               </svg>
//             </button>
//           </div>
//         </div>

//         {/* Footer Links */}
//         <div className="ap-card" style={{ padding: "22px 28px" }}>
//           <div className="ap-footer-grid">
//             {/* Agency Platforms */}
//             <div>
//               <div className="ap-section-label">AGENCY PLATFORMS</div>
//               {agencyPlatforms.map((p) => (
//                 <div
//                   key={p.label}
//                   className="ap-footer-link"
//                   onClick={() => {
//                     if (p.link) {
//                       window.open(p.link, "_blank");
//                     }

//                     if (p.pdf) {
//                       window.open(p.pdf, "_blank");
//                     }
//                   }}
//                 >
//                   <div
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       gap: "10px",
//                     }}
//                   >
//                     <span className="ap-footer-icon">
//                       <svg
//                         width="14"
//                         height="14"
//                         viewBox="0 0 24 24"
//                         fill="none"
//                         stroke="currentColor"
//                         strokeWidth="1.5"
//                         strokeLinecap="round"
//                       >
//                         <rect x="3" y="3" width="18" height="18" rx="2" />
//                         <line x1="9" y1="9" x2="15" y2="9" />
//                         <line x1="9" y1="12" x2="15" y2="12" />
//                         <line x1="9" y1="15" x2="12" y2="15" />
//                       </svg>
//                     </span>
//                     <span>{p.label}</span>
//                   </div>

//                   <span style={{ color: "#3a3020", flexShrink: 0 }}>
//                     <ExtIcon />
//                   </span>
//                 </div>
//               ))}
//             </div>

//             {/* Agent Access - with dropdown for Carrier Toolkit */}
//             <div>
//               <div className="ap-section-label">AGENT ACCESS</div>
//               {agentAccess.map((p) => (
//                 <div key={p.label}>
//                   {p.hasDropdown ? (
//                     <div className="ap-relative" ref={toolkitRef}>
//                       <div className="ap-footer-link" onClick={handleToolkitClick}>
//                         <div
//                           style={{
//                             display: "flex",
//                             alignItems: "center",
//                             gap: "10px",
//                           }}
//                         >
//                           <span className="ap-footer-icon">
//                             <svg
//                               width="14"
//                               height="14"
//                               viewBox="0 0 24 24"
//                               fill="none"
//                               stroke="currentColor"
//                               strokeWidth="1.5"
//                               strokeLinecap="round"
//                             >
//                               <rect x="3" y="11" width="18" height="11" rx="2" />
//                               <path d="M7 11V7a5 5 0 0 1 10 0v4" />
//                             </svg>
//                           </span>
//                           <span>{p.label}</span>
//                         </div>
//                         <span style={{ color: "#3a3020", flexShrink: 0 }}>
//                           <ChevronIcon isOpen={openToolkit} />
//                         </span>
//                       </div>
//                       {openToolkit && (
//                         <div className="ap-dropdown">
//                           {p.options && p.options.map((opt) => (
//                             <div
//                               key={opt.label}
//                               className="ap-dropdown-item"
//                               onClick={() => handleOptionClick(opt.link)}
//                             >
//                               <span>{opt.label}</span>
//                               <ExtIcon />
//                             </div>
//                           ))}
//                         </div>
//                       )}
//                     </div>
//                   ) : (
//                     <div
//                       className="ap-footer-link"
//                       onClick={() => {
//                         if (p.link) {
//                           window.open(p.link, "_blank");
//                         }
//                         if (p.pdf) {
//                           window.open(p.pdf, "_blank");
//                         }
//                       }}
//                     >
//                       <div
//                         style={{
//                           display: "flex",
//                           alignItems: "center",
//                           gap: "10px",
//                         }}
//                       >
//                         <span className="ap-footer-icon">
//                           <svg
//                             width="14"
//                             height="14"
//                             viewBox="0 0 24 24"
//                             fill="none"
//                             stroke="currentColor"
//                             strokeWidth="1.5"
//                             strokeLinecap="round"
//                           >
//                             <rect x="3" y="11" width="18" height="11" rx="2" />
//                             <path d="M7 11V7a5 5 0 0 1 10 0v4" />
//                           </svg>
//                         </span>
//                         <span>{p.label}</span>
//                       </div>
//                       <span style={{ color: "#3a3020", flexShrink: 0 }}>
//                         {p.hasExt ? <ExtIcon /> : <ChevronIcon isOpen={false} />}
//                       </span>
//                     </div>
//                   )}
//                 </div>
//               ))}
//             </div>

//             {/* Operations */}
//             <div>
//               <div className="ap-section-label">OPERATIONS</div>
//               {operations.map((p) => (
//                 <div
//                   onClick={() => {
//                     if (p.link) {
//                       window.open(p.link, "_blank");
//                     }

//                     if (p.pdf) {
//                       window.open(p.pdf, "_blank");
//                     }
//                   }}
//                   key={p.label}
//                   className="ap-footer-link"
//                 >
//                   <div
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       gap: "10px",
//                     }}
//                   >
//                     <span className="ap-footer-icon">{p.icon}</span>
//                     <span>{p.label}</span>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }
